import React, { Component } from 'react'
import shortid from 'shortid'

import './OriginSelector.css';

class OriginSelector extends Component {

  constructor(props){
    super(props);

    this.state = {
      value: props.value || { x: 0, y: 0},
      size: props.size,
      disabled: props.disabled
    }
  }

  componentWillReceiveProps(newProps){
    this.setState({
      value: newProps.value || { x: 0, y: 0},
      size: newProps.size,
      disabled: newProps.disabled
    })
  }

  render(){
    const state = this.state;
    const props = this.props;
    const value = state.value;

    var list = [];

    for(var y = -Math.floor(state.size/2); y <= Math.floor(state.size/2); y++){
      list.push([]);
      for(var x = -Math.floor(state.size/2); x <= Math.floor(state.size/2); x++){
        list[list.length - 1].push(x);
      }
    }

    return <div className="origin-selector">
      {
        list.map(function(d, y){
          return <div className="origin-selector-row" key={y}>
            {
              d.map(function(k, x){
                if(value.x == x - Math.floor(state.size/2) && value.y == y - Math.floor(state.size/2)){
                  return <i className="fas fa-circle fa-fw" key={x + '-' + y}/>  
                }
                return <span key={x + '-' + y} onClick={(e) => { props.onClick({x: x - Math.floor(state.size/2), y: y - Math.floor(state.size/2)}) }}>
                  <i className="far fa-circle fa-fw"/>
                </span>
              })
            }
          </div>
        })
      }
    </div>
  }
}

export default OriginSelector;


// WEBPACK FOOTER //
// ./src/components/OriginSelector/OriginSelector.js